import {
    configStringToValidatedCurrencyString,
    parseCommaSeperatedNumber,
    roundTo,
    valueToCurrency
} from "./helperFunction";

export default function processPresaleFee(price, relevantData, currencyOptions, generalOptions, presaleFee, preSalePercent, includingFees, ticketFeeData) {

    const {presale_fee_type} = relevantData;

    if (presale_fee_type === 'inapplicable') {
        presaleFee.textContent = generalOptions.nofee;
    }

    if (presale_fee_type === 'fix') {
        presaleFee.textContent = configStringToValidatedCurrencyString(relevantData.presale_fee_fix, currencyOptions, generalOptions, true);
    }

    if (presale_fee_type === 'variable') {
        let bookingFee = calculatePresaleFee(price, ticketFeeData, currencyOptions, generalOptions, preSalePercent, includingFees);
        presaleFee.textContent = valueToCurrency(bookingFee, currencyOptions);
    }
}

export function getPreSalePercent(relevantData, presale_fee_type) {
    if (presale_fee_type === 'variable') {
        return parseCommaSeperatedNumber(relevantData.presale_fee_variable);
    }
    return 0;
}

function calculatePresaleFee(price, ticketFeeData, currencyOptions, generalOptions, preSalePercent, includingFees) {
    let result;

    if (includingFees) {
        result = roundTo((price - ticketFeeData.addition) / (100 + ticketFeeData.percent + preSalePercent) * preSalePercent, currencyOptions, generalOptions);
    } else {
        result = roundTo(price * (preSalePercent / 100), currencyOptions, generalOptions);
    }
    return result;
}
